<template>
  <div v-if="!isCancellationCompleted">
    <div :class="componentClassName">
      <a-page-heading>契約情報確認・変更</a-page-heading>
      <a-select-field
        v-if="companyID === POINT && companyIDList.length !== 0"
        id="companySearch"
        v-model="selectedCompanyID"
        :options="companyIDList"
        :searchable="true"
      />
      <m-section variant="fullpage">
        <m-action-card title="解約のお手続き" icon="user" :header-border="true" :narrow-body="true">
          <form ref="form" class="t-contract-edit-cancel-account__form">
            <div class="t-contract-edit-cancel-account__fields">
              <m-application-summary>
                <a-application-summary-item
                  v-for="(item, index) in currentData"
                  :key="index"
                  :title="item.title"
                  :notes="item.notes"
                >
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <div v-html="item.description" />
                </a-application-summary-item>
              </m-application-summary>
              <!-- <m-action-card
                v-if="!isCancellationConfirm"
                class="t-contract-edit-cancel-account__field-options"
                title="解約理由"
                :border="true"
                :header-border="true"
              > -->
              <m-action-card
                id="relocationGuidance"
                class="t-contract-edit-cancel-account__field-options"
                title="移転ガイダンス"
                :border="true"
                :header-border="true"
                :help="true"
                @help:click="helpModalVisible = true"
              >
                <a-switch v-model="relocationGuidanceSettingFlag" label="移転ガイダンスを利用する" />
                <div
                  v-for="item in phonenumberList"
                  v-show="relocationGuidanceSettingFlag"
                  :key="item.phonenumber"
                  class="t-contract-edit-cancel-account__relocation-guidance-item"
                >
                  <a-switch
                    v-model="relocationGuidanceFlags[item.phonenumber]"
                    :label="`${item.numberName || '未設定'}(${item.phonenumber}) の移転ガイダンスを設定`"
                  />
                  <a-text-field
                    v-show="relocationGuidanceFlags[item.phonenumber]"
                    v-model="relocationGuidances[item.phonenumber]"
                    type="textarea"
                    rows="7"
                    placeholder="おかけになった電話番号が変わりました。
新しい番号は、△△△△△△△△△△です。"
                  />
                  <a-button
                    v-show="relocationGuidanceFlags[item.phonenumber] && !isVoicePlayingList[item.phonenumber]"
                    id="play"
                    variant="fill"
                    color="primary"
                    size="small"
                    icon="play"
                    icon-color="white"
                    @click="handlePlayVoice(relocationGuidances[item.phonenumber], item.phonenumber)"
                  >
                    テスト再生
                  </a-button>
                  <a-button
                    v-show="relocationGuidanceFlags[item.phonenumber] && isVoicePlayingList[item.phonenumber]"
                    id="stop"
                    variant="fill"
                    color="primary"
                    size="small"
                    icon="audio-pause"
                    icon-color="white"
                    @click="handleStopVoice(item.phonenumber)"
                  >
                    テスト停止
                  </a-button>
                </div>
              </m-action-card>
              <m-action-card
                id="reasonForTermination"
                class="t-contract-edit-cancel-account__field-options"
                title="解約理由"
                :border="true"
                :header-border="true"
              >
                <m-form-input label="理由を選択">
                  <a-select-field
                    id="reasonForTerminationSelect"
                    v-model="cancellationReason.reason"
                    :options="reasonList"
                    :error="getFieldError()"
                    @change="handleReasonChange"
                  />
                </m-form-input>
                <!-- <m-form-input label="自由記入">
                  <a-text-field
                    v-model="cancellationReason.description"
                    type="textarea"
                    rows="7"
                    placeholder="（例）お電話いただきありがとうございます。株式会社フォーディジットです。商品の購入に関するお問い合わせの方は1を、商品の返品・故障に関するお問い合わせは2を、それ以外の方は3を押してください。"
                  />
                </m-form-input> -->
                <m-form-input v-if="cancellationReason.reason === '0'" label="自由記述">
                  <!-- <a-text-field
                    v-model="cancellationReason.description"
                    type="textarea"
                    rows="7"
                    placeholder="ご記入ください。"
                    :error="getFieldError()"
                  /> -->
                  <div class="a-text-field a-text-field--text">
                    <textarea
                      id="freeDescription"
                      v-model="cancellationReason.description"
                      class="a-text-field__input"
                      placeholder="ご記入ください。"
                      maxlength="100"
                      :error="getFieldError()"
                    />
                  </div>
                </m-form-input>
              </m-action-card>
              <!-- <m-form-action-buttons v-if="!isCancellationConfirm"> -->
              <m-form-action-buttons>
                <!-- <a-button variant="block" color="primary" submit="submit">キャンセル</a-button>
                <a-button variant="outlined" color="primary" @click="handleCancelClick">解約する</a-button> -->
                <a-button id="cancel" variant="block" color="primary" @click="handleCancelClick">キャンセル</a-button>
                <a-button
                  id="terminate"
                  variant="outlined"
                  color="primary"
                  :disabled="disableFlag || !flagCancelButtonEnable"
                  @click="handleClickCancelContractButton"
                >
                  解約する
                </a-button>
              </m-form-action-buttons>
            </div>
          </form>
        </m-action-card>
      </m-section>
    </div>
    <teleport to="body">
      <o-modal
        id="ContractEditCancelAccount_ConfirmationModal"
        v-model:visible="cancelAccountDialogVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
      >
        <template #title>{{ accountCancellationConfirmationTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="accountCancellationConfirmationMessageText" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="approveDlgCancel"
            variant="block"
            color="primary"
            label="キャンセル"
            size="small"
            @click="handleCloseModal"
          />
          <!-- <a-button variant="block" color="primary" label="解約する" size="small" /> -->
          <a-button
            id="approveDlgOk"
            variant="outlined"
            color="primary"
            label="解約する"
            size="small"
            :disabled="handleAccountCancellationConfirmClickFlag"
            @click="handleAccountCancellationConfirmClick"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="ContractEditCancelAccount_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="ok"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModalInfoAndError"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="ContractEditCancelAccount_RelocationGuidanceConfirmationModal"
        v-model:visible="relocationGuidanceConfirmModalVisible"
        class="o-modal-relocation-guidance-confirmation"
        footer-variant="confirmation"
        width="510px"
        :footer-shadow="false"
        :show-header="false"
      >
        <a-text :center="true"><h2>解約の確認</h2></a-text>
        <br />
        <a-text>番号は廃止となり、再度利用することは出来ませんのでご注意ください。</a-text>
        <br />
        <a-text>移転ガイダンスありの電話番号</a-text>
        <a-text weight="bold">
          {{ relocationGuidanceOnList.length ? relocationGuidanceOnList.join(', ') : 'なし' }}
        </a-text>
        <br />
        <a-text>移転ガイダンスなしの電話番号</a-text>
        <a-text weight="bold">
          {{ relocationGuidanceOffList.length ? relocationGuidanceOffList.join(', ') : 'なし' }}
        </a-text>
        <template #footer>
          <a-button
            id="approveDlgCancel"
            variant="block"
            color="primary"
            label="キャンセル"
            size="small"
            @click="handleHideRelocationGuidanceConfirmModal"
          />
          <a-button
            id="approveDlgOk"
            variant="outlined"
            color="primary"
            label="解約に進む"
            size="small"
            @click="handleClickContinueCancelContractButton"
          />
        </template>
      </o-modal>
    </teleport>
    <teleport to="body">
      <o-modal
        id="ContractEditCancelAccount_helpModal"
        v-model:visible="helpModalVisible"
        class="o-modal-contract-edit-cancel-help"
        footer-variant="confirmation"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <template #title>移転ガイダンスについて</template>
        <a-text>
          解約後に着信があった場合について自動音声ガイダンスを流すことが可能です。
          <br />移転ガイダンスの利用は無料です。 <br />解約後約３カ月の間、移転ガイダンスが流れます。
          <br />ただし2025年1月以降に解約した場合は同年3月末をもって移転ガイダンスを停止します。
          <br />設定後のガイダンスの変更や期間の変更は承っておりませんのでご注意ください。
        </a-text>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import MSection from '@/components/molecules/section';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ASelectField from '@/components/atoms/select-field';
import ATextField from '@/components/atoms/text-field';
import MApplicationSummary from '@/components/molecules/application-summary';
import AApplicationSummaryItem from '@/components/atoms/application-summary-item';
import OModal from '@/components/organisms/modal';
import AText from '@/components/atoms/text';
import AApplicationCompleteSign from '@/components/atoms/application-complete-sign';
import ABrandLogo from '@/components/atoms/brand-logo';
import AHeading from '@/components/atoms/heading';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';
import { LP_URL } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2456

// For Trial
import { utils } from '@/common/utils.js';

export default {
  name: 't-contract-edit-cancel-account',
  components: {
    APageHeading,
    MActionCard,
    MSection,
    MFormActionButtons,
    AButton,
    MFormInput,
    MApplicationSummary,
    AApplicationSummaryItem,
    ASelectField,
    OModal,
    AText,
  },
  mixins: [customRequest, messageContent, customValidate], // #2456
  props: {
    class: {
      type: String,
      default: '',
    },
    handleAccountCancellationModalCloseClick: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      cancellationReason: {
        reason: null,
        description: '',
      },
      cancelAccountDialogVisible: false,
      currentData: [],
      reasonList: [],
      accountCancellationConfirmationTitle: '',
      accountCancellationConfirmationMessageText: '',
      isCancellationConfirm: false,
      isCancellationCompleted: false,
      selectedCompanyID: '',
      reasonData: {},
      disableFlag: true,
      contractStatusFlag: false,
      companyIDList: [],
      POINT,
      handleAccountCancellationConfirmClickFlag: false,
      flagCancelButtonEnable: true, //#1892
      authInfo: this.$store.state.user.authInfo, // #2328
      // 移転ガイダンス
      relocationGuidanceSettingFlag: false, // 移転ガイダンスを利用するトグル値
      phonenumberList: [],
      relocationGuidanceFlags: {}, // 電話番号ごとの移転ガイダンス設定トグル値
      relocationGuidances: {}, // 電話番号ごとの移転ガイダンス
      audio: null,
      isVoicePlayingList: {},
      helpModalVisible: false,
      // 移転ガイダンス確認モーダル
      relocationGuidanceConfirmModalVisible: false,
      relocationGuidanceOnList: [],
      relocationGuidanceOffList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-edit-cancel-account');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    isCancellationConfirm(val) {
      if (val) {
        this.showCancellationCompletedModal();
      }
    },
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        // 連続に2回ルーターpushするのを禁止する
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }

        if (!utils.chkTrialCompanyID(this.companyID)) {
          this.fetchContractDataHandler();
          this.fetchCancelReasonDataHandler();
        }
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
    },
  },
  created() {
    this.selectedCompanyID = this.$route.query.companyID ? this.$route.query.companyID : this.companyID;
    // #2328
    let invalidFlag = false;
    // soOperatorはメニューではねている=改竄されている
    if (this.authInfo === 'soOperator') {
      invalidFlag = true;
    }
    // POINT以外でログインした企業ID以外が指定されてきた=企業IDが改竄されている
    if (this.companyID !== POINT && this.selectedCompanyID !== this.companyID) {
      invalidFlag = true;
    }
    // POINT以外でかつ権限が(manager||operator)=メニューではねられるはずなので改竄疑い
    if (this.companyID !== POINT && (this.authInfo === 'manager' || this.authInfo === 'operator')) {
      invalidFlag = true;
    }
    // ログインがPOINTかつPOINT選択はできないはず=改竄疑い
    if (this.companyID === POINT && this.selectedCompanyID === POINT) {
      invalidFlag = true;
    }
    // For Trial
    if (
      utils.chkTrialCompanyID(this.companyID) ||
      (this.companyID === POINT && utils.chkTrialCompanyID(this.selectedCompanyID))
    ) {
      invalidFlag = true;
    }
    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }

    if (this.companyID === POINT) {
      this.fetchCompanyIDListHandler();
    }
  },
  mounted() {
    if (this.reasonList.length > 0 && this.reasonList[0].value) {
      this.cancellationReason.reason = this.reasonList[0].value;
    }
    if (this.isCancellationConfirm) {
      this.showCancellationCompletedModal();
    }
  },
  methods: {
    handleCloseModalInfoAndError() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleClickCancelContractButton() {
      this.relocationGuidanceOnList = []; // 移転ガイダンスの確認モーダル表示用
      if (this.relocationGuidanceSettingFlag) {
        // Validate transfer guidance
        for (const phonenumber in this.relocationGuidanceFlags) {
          if (!this.relocationGuidanceFlags[phonenumber]) continue;
          this.relocationGuidanceOnList.push(phonenumber);
          const guidance = this.relocationGuidances[phonenumber];
          // empty check
          if (!guidance) {
            this.showErrorModal(messageContent.emptyGuidanceError);
            return;
          }
          // 長さチェック
          const lengthCheck = this.guidanceLengthCheck(guidance);
          if (!lengthCheck.status) {
            this.showErrorModal(lengthCheck.message);
            return;
          }
          // Only space check for guidance
          const onlySpaceChk = this.onlySpaceCheck(guidance, '移転ガイダンス内容');
          if (!onlySpaceChk.status) {
            this.showErrorModal(onlySpaceChk.message);
            return;
          }
          // 特殊文字チェック
          if (this.hasSpecialCharacterInObject(guidance)) {
            this.showErrorModal(messageContent.hasSpecialCharacter);
            return;
          }
          const charCheck = this.guidanceCharCheck(guidance);
          if (!charCheck.status) {
            this.showErrorModal(charCheck.message);
            return;
          }
        }
      }

      this.relocationGuidanceOffList = []; // 移転ガイダンスの確認モーダル表示用
      for (const phonenumber in this.relocationGuidanceFlags) {
        if (!this.relocationGuidanceOnList.includes(phonenumber)) this.relocationGuidanceOffList.push(phonenumber);
      }
      this.relocationGuidanceConfirmModalVisible = true;
    },
    handleClickContinueCancelContractButton() {
      this.relocationGuidanceConfirmModalVisible = false;
      this.handleFormSubmit();
    },
    handleHideRelocationGuidanceConfirmModal() {
      this.relocationGuidanceConfirmModalVisible = false;
    },
    handleFormSubmit: async function () {
      this.flagCancelButtonEnable = false; //#1892
      this.setLoading(true);
      const constractStatusResult = await this.checkContractStatus();
      this.setLoading(false);
      if (!constractStatusResult) {
        this.flagCancelButtonEnable = true; //#1892
        return;
      }

      if (!this.cancellationReason.reason) {
        this.showErrorModal(messageContent.alertCancelReason());
        this.flagCancelButtonEnable = true; //#1892
        return;
      }
      const payload = cloneDeep(this.cancellationReason);

      try {
        this.reasonData = { cancelNumber: payload.reason, cancelReason: payload.description };
        // #2456
        if (this.hasSpecialCharacterInObject({ keyWord: payload.description.replace(/\r?\n/g, '') })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter('自由記述'));
          this.flagCancelButtonEnable = true; //#1892
          return;
        }

        const validateResult2 = await this.validataCancelReason(this.reasonData);
        if (!validateResult2) {
          this.flagCancelButtonEnable = true; //#1892
          return;
        }

        this.accountCancellationConfirmationTitle = messageContent.titleCancelContract();
        this.accountCancellationConfirmationMessageText = messageContent.alertCancelContract();
        this.isCancellationConfirm = true;
        this.isCancellationCompleted = false;
      } catch (error) {
        console.log(error);
        this.showErrorModal(messageContent.requireTry('解約処理'));
        this.flagCancelButtonEnable = true; //#1892
      }

      this.cancelAccountDialogVisible = true;
      this.flagCancelButtonEnable = true;

      // this.handleAccountCancellationConfirmClick(payload);
    },
    showCancellationCompletedModal() {
      this.cancelAccountDialogVisible = true;
    },
    handleCloseModal() {
      this.cancelAccountDialogVisible = false;
      // this.handleAccountCancellationModalCloseClick();
      this.isCancellationConfirm = false;
      this.isCancellationCompleted = false;
      this.flagCancelButtonEnable = true; //#1892
    },
    handleCancelClick() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/contract', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push({ path: '/contract' });
      }
    },
    handleAccountCancellationConfirmClick: async function () {
      try {
        this.cancelAccountDialogVisible = false;
        this.handleAccountCancellationConfirmClickFlag = true;

        // #2138 textareaの改行コードを変換
        if (typeof this.reasonData.cancelReason !== 'undefined' && this.reasonData.cancelReason !== null) {
          this.reasonData.cancelReason = this.reasonData.cancelReason.replace(/\n/g, '%%n%%');
        }

        this.setLoading(true);
        const cancelResult = await this.cancelContract(this.reasonData);
        if (!cancelResult) {
          this.setLoading(false);
          this.flagCancelButtonEnable = true; //#1892
          this.handleAccountCancellationConfirmClickFlag = false;
          return;
        }

        const mailResult = await this.sendMail();
        if (!mailResult) {
          this.setLoading(false);
          this.flagCancelButtonEnable = true; //#1892
          this.handleAccountCancellationConfirmClickFlag = false;
          return;
        }

        // サービス終了後の強制解約処理のために、ユーザーへのメールは送信停止しておく
        // const usermailResult = await this.sendUserMail();
        // if (!usermailResult) {
        //   this.setLoading(false);
        //   this.flagCancelButtonEnable = true; //#1892
        //   this.handleAccountCancellationConfirmClickFlag = false;
        //   return;
        // }

        // 確認モーダルで「解約する」ボタンが押された時の処理を追加
        this.cancelAccountDialogVisible = false; //#1892 #2148
        this.handleAccountCancellationConfirmClickFlag = false;

        this.flagCancelButtonEnable = true; //#1892
        if (this.companyID !== POINT) {
          await this.logout();
        } else {
          this.isCancellationConfirm = false;
          this.cancelAccountDialogVisible = false;
          this.showInfoModal(messageContent.notifyCancelContractAccepted());
        }
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        console.log(error);
        this.showErrorModal(messageContent.requireTry('解約処理'));
        this.flagCancelButtonEnable = true; //#1892
        this.handleAccountCancellationConfirmClickFlag = false;
      }
    },
    getFieldError(key) {
      this.disableFlag = true;
      if (this.contractStatusFlag) {
        return;
      }
      if (this.cancellationReason.reason) {
        if (this.cancellationReason.reason === '0' && !this.cancellationReason.description) {
          this.disableFlag = true;
        } else {
          this.disableFlag = false;
        }
      }
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlist')
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の取得'));
        });
    },
    fetchContractDataHandler: async function () {
      await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
        authInfo: this.authInfo ? this.authInfo : '',
      })
        .then(e => {
          this.phonenumberList = e.phonenumberList;
          for (const item of e.phonenumberList) {
            this.relocationGuidances[item.phonenumber] = '';
            this.relocationGuidanceFlags[item.phonenumber] = true;
          }
          this.currentData = [
            {
              title: '氏名',
              description: e.data.view_adminName,
            },
            {
              title: '氏名カナ',
              description: e.data.view_adminKanaName,
            },
            {
              title: '生年月日',
              description: e.data.adminBirthDate.replace(/-/g, '/'),
            },
            {
              title: '電話番号',
              description: e.data.adminPhoneNumber,
            },
            {
              title: 'メールアドレス',
              description: e.data.adminEmail,
            },
            {
              title: '郵便番号',
              description: e.data.adminPostCode,
            },
            {
              title: '都道府県名',
              description: e.data.adminAddress1,
            },
            {
              title: '市区町村',
              description: e.data.adminAddress2,
            },
            {
              title: '字丁目番地など',
              description: e.data.adminAddress3,
            },
            {
              title: '住所建物など',
              description: e.data.adminAddress4,
            },
            {
              title: '利用開始日',
              description: e.data.startDate.replace(/-/g, '/'),
            },
          ];

          if (e.data.contractStatus === 'close') {
            this.contractStatusFlag = true;
            this.showErrorModal(messageContent.alertNowCanceling());
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報の取得'));
        });
    },
    checkContractStatus: async function () {
      return await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.data.contractStatus === 'close') {
            this.contractStatusFlag = true;
            this.showErrorModal(messageContent.alertNowCanceling());
            return false;
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報の取得'));
        });
    },
    fetchCancelReasonDataHandler: async function () {
      await this.postRequest('/contract/getcancelationinfo', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          const result = e.result;

          const keys = Object.keys(result);

          // #2408
          this.reasonList.length = 0;

          const cancellReasonServiceEndNumStr = '8';
          for (let i = 0; i < keys.length; i++) {
            if (keys[i] === cancellReasonServiceEndNumStr) {
              // 「サービス提供終了のため」は一番上に表示したいため、後で配列の先頭に追加する
              continue;
            }
            const data = {
              value: keys[i],
              label: result[keys[i]],
            };
            this.reasonList.push(data);
          }
          this.reasonList.unshift({
            value: cancellReasonServiceEndNumStr,
            label: result[cancellReasonServiceEndNumStr],
          });
          const data = {
            value: '0',
            label: 'その他(自由記述)',
          };
          this.reasonList.push(data);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報の取得'));
        });
    },
    validataCancelReason: async function (reasonData) {
      return await this.postRequest('/contract/validataCancelReason', {
        data: reasonData,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            if (e.msg) {
              this.showErrorModal(e.msg);
            }
            return false;
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('解約理由の確認'));
        });
    },
    cancelContract: async function (reasonData) {
      // 移転ガイダンスデータ
      const relocationData = [];
      for (const phonenumber of this.relocationGuidanceOnList) {
        relocationData.push({
          phonenumber,
          guidance: this.relocationGuidances[phonenumber].replace(/\n/g, '%%n%%'),
        });
      }
      return await this.postRequest('/contract/cancelContract', {
        data: reasonData,
        relocationData,
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            if (e.msg) {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry('解約処理'));
            }
            return false;
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('解約処理'));
        });
    },
    sendMail: async function (businessType, date) {
      return await this.postRequest('/contract/sendoperatormailforcancel', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            throw new Error('/contract/sendoperatormailforcancel response was not ok.');
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('解約処理'));
        });
    },
    sendUserMail: async function () {
      return await this.postRequest('/contract/sendusermailforcancel', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          if (e.status === 'failed') {
            throw new Error(messageContent.httpRequestError('/contract/sendusermailforcancel'));
          }
          return true;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('解約処理'));
        });
    },
    logout: async function () {
      const self = this;
      await this.postRequest('/login/logout').then(data => {
        if (data.status === 'success') {
          // self.handleLogout();
          this.$router.push('/contract/cancelcomplete');
          // window.location.href = '/login';
        } else {
          this.showErrorModal(messageContent.requireTry('ログアウト'));
        }
      });
    },
    // #2456と同時に修正。解約理由が変更になった場合に自由入力フィールドをクリアする処理を追加
    handleReasonChange: function () {
      this.cancellationReason.description = '';
    },
    async handlePlayVoice(content, phonenumber) {
      if (!content) {
        this.showErrorModal(messageContent.emptyGuidanceError);
        return;
      }
      if (content && this.hasSpecialCharacterInObject(content)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      const lengthCheck = this.guidanceLengthCheck(content);
      if (!lengthCheck.status) {
        this.showErrorModal(lengthCheck.message);
        return;
      }
      const onlySpaceChk = this.onlySpaceCheck(content, '移転ガイダンス内容');
      if (!onlySpaceChk.status) {
        this.showErrorModal(onlySpaceChk.message);
        return;
      }
      const charCheck = this.guidanceCharCheck(content);
      if (!charCheck.status) {
        this.showErrorModal(charCheck.message);
        return;
      }
      if (this.audio && this.audio.state === 'running') this.audio.close();
      this.isVoicePlayingList = {};
      this.isVoicePlayingList[phonenumber] = true;
      const self = this;
      await this.postRequest('/servicecondition/testvoice', {
        content: content,
        selectedCompanyID: this.selectedCompanyID,
        selectedPhoneNumber: phonenumber,
      })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlayingList[phonenumber] = false;
            };
          } else {
            this.isVoicePlayingList[phonenumber] = false;
            self.showErrorModal(messageContent.playbackError);
          }
        })
        .catch(error => {
          this.isVoicePlayingList[phonenumber] = false;
          self.showErrorModal(messageContent.playbackError);
        });
    },
    handleStopVoice(phonenumber) {
      if (this.audio && this.audio.state === 'running') {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlayingList[phonenumber] = false;
        });
      }
    },
  },
};
</script>
